import type { Editor } from '@tiptap/react';

import { createReactionState } from '../../../chips/reactionUtils';
import { updateTaskItemAttrs } from './taskListItemAttrUtils';
import type { TaskItemReaction } from './taskListItemChipTypes';

/** Reads the `reactions` attr off a task item node's attrs, defaulting to an empty list. */
export const getTaskItemReactions = (attrs: Record<string, unknown> | undefined): TaskItemReaction[] =>
    (attrs?.reactions as TaskItemReaction[] | undefined) ?? [];

/** The emoji codes the given user has reacted with (used to mark the picker's selected emoji). */
export const getSelectedReactionEmojiCodes = (
    reactions: TaskItemReaction[],
    currentUserId: string | undefined,
): string[] =>
    reactions.filter((reaction) => reaction.userId === currentUserId).map((reaction) => reaction.emojiCode);

/**
 * Toggles `emojiCode` for `currentUserId` on the task item node at `position`. Reuses
 * the element `createReactionState` toggle so node-attr and element reactions stay
 * consistent.
 */
export const toggleTaskItemReaction = ({
    editor,
    position,
    currentUserId,
    emojiCode,
}: {
    editor: Editor;
    position: number;
    currentUserId: string;
    emojiCode: string;
}): void => {
    updateTaskItemAttrs({
        editor,
        position,
        update: (attrs) => ({
            reactions: createReactionState({
                existingReactionState: getTaskItemReactions(attrs),
                emojiCode,
                userId: currentUserId,
            }),
        }),
    });
};
